<h1 mat-dialog-title>Save &amp; Share Report Export</h1>
<div mat-dialog-content>
  <form class="standard-form">
    <mat-form-field>
      <mat-label>Name (required)</mat-label>
      <input
        matInput
        [readonly]="!data.isNewExport"
        name="name"
        [(ngModel)]="data.name"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input
        matInput
        [readonly]="!data.isNewExport"
        name="description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <mat-form-field *ngIf="data.isNewExport">
      <mat-select [(value)]="data.exportFormat">
        <mat-option value="pdf">PDF</mat-option>
        <mat-option value="pptx">PPTX</mat-option>
      </mat-select>
      <mat-label>Export Format</mat-label>
    </mat-form-field>
  </form>
  <app-share-editor
    allowReadOnly="true"
    allowModify="true"
    [(ngModel)]="data.shareState"
    [avaialbleSubscriptions]="data.userSubscriptions"
  ></app-share-editor>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
